import videojs from 'video.js';

const Button = videojs.getComponent('Button');

class FillWindowToggle extends Button {
  constructor(player, options) {
    super(player, options);
    this.addClass('vjs-fill-window-button');
    this.addClass('vjs-icon-fill-window');
    this.controlText('Fill window');
  }

  handleClick(event) {
    this.player_.toggleClass('vjs-fill-window-mode');
    if (this.player_.hasClass('vjs-fill-window-mode')) {
      videojs.addClass(document.body, 'vjs-fill-window-mode');
    } else {
      videojs.removeClass(document.body, 'vjs-fill-window-mode');
    }
  }
}

videojs.options.languages.en['Fill window'] = 'Fill window';
videojs.options.languages.ru['Fill window'] = 'Во все окно';
videojs.options.languages.uk['Fill window'] = 'Во все окно';

const ControlBar = videojs.getComponent('ControlBar');
const fullscreenToggleIdx = ControlBar.prototype.options_.children.indexOf('fullscreenToggle');
ControlBar.prototype.options_.children.splice(fullscreenToggleIdx, 0, 'fillWindowToggle');

videojs.registerComponent('FillWindowToggle', FillWindowToggle);
export default FillWindowToggle;



// WEBPACK FOOTER //
// ./src/components/videojs-fill-window-toggle.js